import { Container, Flex, Text } from "@chakra-ui/react";
import Head from "next/head";
import React, { useEffect, useState } from "react";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

export default function Valuacion() {
    const [screenSize, getDimension] = useState({
        winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
        winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
    });

    const setDimensions = () => {
        getDimension({
            winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
            winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", setDimensions);

        return () => {
            window.removeEventListener("resize", setDimensions);
        };
    }, [screenSize]);

    return (
        <>
            <Head>
                <title>ThankYouPage Valuación | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/thankyoupage-nueva-valuacion" />
                <link
                    rel="alternate"
                    href="https://grupoguia.mx/thankyoupage-nueva-valuacion"
                    hrefLang="es-mx"
                />
            </Head>
            <Header />
            <Container
                maxW="100vw"
                {...(screenSize.winWidth <= 768 && { paddingInline: "0" })}
                paddingTop="8rem"
                paddingBottom="6rem"
                px={5}
            >
                <Flex
                    justifyContent="center"
                    flexDirection="column"
                    alignItems="center"
                    textAlign={{ base: "center", md: "initial" }}
                >
                    <Text fontSize="2xl" fontWeight="700">
                        ¡Gracias!
                    </Text>
                    <Text marginTop="0.5rem" marginBottom="1rem" fontSize="md">
                        Hemos recibido tu información exitosamente
                    </Text>
                    <Text marginTop="0.5rem" marginBottom="4rem" fontSize="md">
                        Un asesor se pondrá en contacto contigo muy pronto para comunicarte los
                        siguientes pasos
                    </Text>
                </Flex>
            </Container>
            <Footer />
        </>
    );
}
